<template>
  <div>
    <div
      @click="handleClick"
      @dragover="handleDragover"
      @drop.prevent="handleDrop"
      @dragenter.prevent="handleDragEnter" @dragleave.prevent="handleDragLeave"
      :class="nodeClass"
    >
      <div class="d-flex w-100">
        <a v-if="node.type !== 'partner'"
           @click.prevent.stop="toggleChildren"
           :disabled="!showDetailsButton"
        >
          <b-icon v-if="collapsed" icon="chevron-right" variant="secondary"/>
          <b-icon v-else icon="chevron-down" variant="secondary"/>
        </a>

        <InlinePartner :partner="node"/>


        <div class="flex-grow-1 d-flex justify-content-end pe-2" >
          <div v-if="highlight" class="text-danger text-small warning align-content-center">
            <small>
              {{draggingAlert}}
            </small>
          </div>

          <div v-if="updating === node.id">
            <b-spinner
              small
              variant="secondary"
              class="ms-2"
            />
          </div>

          <div v-if="showDetails" >
            <a v-if="node.type !== 'instance'"
              @click.prevent="handleClickDetails()"
              v-b-tooltip.hover.top="'Ver detalles'" >
              <b-icon icon="list"/>
            </a>

            <a v-if="node.type !== 'partner'"
              @click.prevent="handleClickShowDocumentHistory()"
              v-b-tooltip.hover.top="'Ver historial de documentos'" >
              <b-icon icon="file-diff"/>
            </a>

            <a v-if="node.nodes.length === 0 && node.type !== 'instance'"
              @click.prevent="handleClickDeleteShareholder()"
              v-b-tooltip.hover.top="'Eliminar'"
            >
              <b-icon icon="file-minus-fill"/>
            </a>
          </div>
          <div v-if="percentage !== null && isSibling" class="percentage ps-1 align-content-center">
              {{ percentage }}%
          </div>
          <div v-else>
            <div v-if="showDetails && node.type !== 'instance'">
              <ShareholdersPercentageForm :parentId="parentId" :childId="node.id"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <nested-draggable v-for="el in node.nodes" :key="el.id"
      v-show="!collapsed"
      :node="el"
      :currentSelection="currentSelection"
      :ancestors="[...ancestors, node]"
      :srcDragId="srcDragId"
      class="mx-0 ps-3"
      @click="handleClick()"
    />
</div>
</template>
<script>
import { EventNames} from "@/plugins/enums";
import { mapActions } from 'vuex';
import InlinePartner from "@/components/shared/Inline-partner.vue";
import ShareholdersPercentageForm from "../ManagedCompaniesMenu/Shareholders-percentage-form.vue";

export default {
  name: "nested-draggable",
  components: {InlinePartner, ShareholdersPercentageForm},
  props: {
    node: {
      required: true,
      type: Object
    },
    currentSelection: {
      type: String,
      required: true
    },
    ancestors: {
      type: Array,
      default: () => []
    },
    srcDragId: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      highlight: false,
      collapsed: false,
      updating: null,
      dragCounter: 0,
      percentage: null,
      showDetails: false,
      isParent: false,
      isSibling: false,
      draggingAlert: null
    }
  },

  methods: {
    ...mapActions(["addShareholder", 'getShareholderPercentage']),

    async handleDragover(event) {
      if (this.node.type === 'partner') {
        return
      }

      event.preventDefault();
    },

    async handleDrop(event) {
      this.highlight = false;
      this.dragCounter = 0

      let childId = event.dataTransfer.getData('text')
      this.updating = this.node.id

      this.$eventBus.$emit(EventNames.StartProcessAddShareholder);

      let result = await this.addShareholder({
        parentNodeId: this.node.id,
        childNodeId: childId
      });

      if (result.isError) {
        this.$eventBus.$emit(EventNames.ShowAlertManagedCompanies, {msg: result.message, type: 'danger'});
        this.$eventBus.$emit(EventNames.EndProcessAddShareholder)
        this.updating = false
        return
      }

      this.$eventBus.$emit(EventNames.ShowAlertManagedCompanies, {msg: 'Asignación realizada correctamente', type: 'success'});
      this.$eventBus.$emit(EventNames.EndProcessAddShareholder);
      this.$eventBus.$emit(EventNames.UpdateShareholderStructure)
      this.updating = null
    },

    handleDragEnter() {
      if (this.node.type === 'partner') {
        return
      }
      this.dragCounter++
      if (this.dragCounter === 1) {
        this.highlight = true
        if (this.node.id === this.srcDragId) {
          this.draggingAlert = 'No se puede agregar a sí mismo'
          return
        }

        let idxChild = this.ancestors.map(x => x.id).indexOf(this.srcDragId)
        if (idxChild !== -1) {
          this.draggingAlert = 'Referencia cíclica'
          return
        }

        if (this.node.nodes.map(x => x.id).includes(this.srcDragId)) {
          this.draggingAlert = 'Socio ya asignado'

        }
      }
    },

    handleDragLeave() {
      if (this.node.type === 'partner') {
        return
      }
      this.dragCounter--
      if (this.dragCounter === 0) {
        this.highlight = false
        this.draggingAlert = null
      }
    },

    toggleChildren() {
      this.collapsed = !this.collapsed
    },

    handleClick() {
      let childIds = this.ancestors.map(x => x.id)
      this.$eventBus.$emit(EventNames.ClickManagedCompany, {childIds, id: this.node.id});
      this.showDetails = true
    },

    handleClickDetails() {
        let parent = this.ancestors[this.ancestors.length - 1];
        this.$eventBus.$emit(EventNames.OpenModalShowCompanyDetails, {node: this.node, parent});
    },

    handleClickShowDocumentHistory() {
      this.$eventBus.$emit(EventNames.OpenModalShowManagedCompanyDocumentHistory, this.node);
    },

    handleClickDeleteShareholder() {
      let parent = this.ancestors[this.ancestors.length - 1];
      this.$eventBus.$emit(EventNames.OpenModalRemoveShareholder, {child: this.node, parent});
    },

    async getPercentage() {
      let parentId = this.ancestors[this.ancestors.length - 1]?.id ?? null;
      if (parentId === null) {
        this.percentage = null
        return
      }

      let result = await this.getShareholderPercentage({parentId, childId: this.node.id})
      if (result.isError) {
        this.$eventBus.$emit(EventNames.ShowAlertManagedCompanies, {msg: result.msg, type: 'danger'})
        this.percentage = null
        return
      }

      this.percentage = result.data?.participation ?? null
    },

    arrayEquals(a, b) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length !== b.length) return false;

      for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    },
  },

  computed: {
    parentId() {
      if (this.ancestors.length !== 0) {
        return this.ancestors[this.ancestors.length - 1].id
      }

      return this.node.id
    },

    nodeClass() {
     return {
        highlight: this.highlight,
        outlined: true,
        detailed: this.showDetails,
        selected: this.node.id === this.currentSelection && !this.showDetails,
      }
    },

    showDetailsButton() {
      return this.node.nodes.length !== 0
    }
  },

  mounted() {
    this.$eventBus.$on(EventNames.UpdatedPercentage, async () => {
      await this.getPercentage()
    })

    this.$eventBus.$on(EventNames.ClickManagedCompany, (data) => {
      let parentsIds = this.ancestors.map(x => x.id)
      this.isSibling = this.arrayEquals(data.childIds, [...parentsIds])
      this.isParent = this.arrayEquals(data.childIds, [...parentsIds, this.node.id]);
      this.showDetails = false
    })

    this.getPercentage()
  },
}
</script>
<style scoped>
a {
  text-decoration: none;
  transition: all 0.3s ease-in-out;
}

a:hover {
  color: dodgerblue;
  text-shadow: 0 0 25px dodgerblue;
}

.highlight {
  background-color: rgba(0, 0, 0, 0.1);
}

.disabled {
  pointer-events: none;
  color: lightgrey;
}

.outlined {
  border-bottom: 1px solid rgba(211, 211, 211, 0.4);
  align-items: center;
}

.selected {
  border-bottom: 1px solid darkgrey;
  align-items: center;
}

.detailed {
  border-bottom: 1px solid darkslategray;
  align-items: center;
}

.toggle:hover {
  cursor: pointer
}

svg {
  color: darkgrey;
}

svg:hover {
  color: black
}

.percentage {
  min-width: 30px;
  font-size: 12px;
  color: darkslategray;
}

.warning {
  font-size: 11px;
}

a[disabled] {
    pointer-events: none;
    opacity: 0.4;
    cursor: not-allowed;
}</style>
